export const ANONYMOUS_LAYOUT_ROUTE_CONFIG = {
  hideHeader: false,
  skipAuth: true,
};
